import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'lib/core/data/reducer'
import { normalizeProduct } from 'lib/modules/catalog'
import { getProductAttributeList } from 'lib/core/data/common/productAttributeList/selectors'
import { Slice, WishlistItem } from './types'

const getSlice = (state: any): Slice => {
  return state.customer.wishlist
}

const getSliceItems = (state: RootState) => {
  const slice = getSlice(state)
  return slice.payload?.items ?? ([] as WishlistItem[])
}

export const getWishlistItems = createSelector(
  (state: RootState) => state,
  state => {
    const productAttributeList = getProductAttributeList(state)
    const items = getSliceItems(state)
    const wishlistItems = items.map(item => {
      return {
        ...item,
        product: normalizeProduct({
          product: item.product,
          productAttributeList,
          storeConfig: state.common.storeConfig.payload
        })
      }
    })
    return wishlistItems
  }
)

export const findItemBySku = (sku: string) => (state: any) => {
  const items = getSliceItems(state)
  return items.find(item => item.product.sku === sku)
}

export const getIsFetching = (state: any) => {
  return getSlice(state).isFetching
}

export const getIsSuccess = (state: any) => {
  return getSlice(state).isSuccess
}
